// Simple key-value storage on localStorage. Async API kept so callers are
// agnostic to the backing store.

const PREFIX = "tide_pref.";

const Storage = {
  async get(key) {
    try {
      return localStorage.getItem(PREFIX + key);
    } catch {
      return null;
    }
  },
  async set(key, value) {
    localStorage.setItem(PREFIX + key, String(value));
  },
  async remove(key) {
    try {
      localStorage.removeItem(PREFIX + key);
    } catch { }
  },
  async clear() {
    try {
      const doomed = [];
      for (let i = 0; i < localStorage.length; i++) {
        const k = localStorage.key(i);
        if (k && k.startsWith(PREFIX)) doomed.push(k);
      }
      doomed.forEach((k) => localStorage.removeItem(k));
    } catch { }
  },
};

export { Storage };
